export interface IUserFeedbackQuestion {
  id: number;
  questionText: string;
  yesText: string;
  noText: string;
  hasComment: boolean;
}

export enum IUserFeedbackQuestionContextType {
  OrderPlaced = 'order-placed',
  // brooks
  PanelBoughtThisSeason = 'panel-bought-this-season',
  // puma after filters update
  InterfaceUpdate = 'interface-update',
}

export enum IUserFeedbackAnimationType {
  SlideFromLeft = 'slideFromLeft',
  SlideFromRight = 'slideFromRight',
}
